export default {
  cdnId: 'og-image',
  width: 1200,
  aspect: '2/1',
  quality: 75
};
